export default {"src":"/_next/static/media/ollie-logo.e779fd0c.svg","height":60,"width":126,"blurWidth":0,"blurHeight":0};